import { ViewPackInfo, ViewPackListItem } from '@/dashboard/shared/types/widgets.types';
import { convertToImageURL } from '@/dashboard/features/editToolbox/domain/convertToImageURL';
import { Category } from './viewPackList.constant';
import { kebabCase } from 'lodash-es';
import { IconType } from '@/types/icon.types';
import { ALL_ICON_SET } from '@/common/define/icon.define';

const getViewPackIconClass = (chartType: string, displayStyle: string): IconType => {
  if (chartType === 'GROUP') {
    return 'icon-widget-group';
  }

  if (chartType === 'TAB_GROUP') {
    return 'icon-widget-tab-group';
  }

  const iconClass = displayStyle
    ? `icon-${kebabCase(chartType)}-${kebabCase(displayStyle)}`
    : `icon-widget-${kebabCase(chartType)}`;

  if (ALL_ICON_SET.has(iconClass)) {
    return iconClass as IconType;
  }

  return 'icon-widget-table';
};

export const toViewPackListItems = (packs: ViewPackInfo[]): ViewPackListItem[] =>
  packs.map(
    ({
      packId,
      packType,
      name,
      image,
      description,
      createUserName,
      createUserRole,
      tag,
      category,
      viewPackOptions,
      widgets,
    }) => {
      const imgSrc = !image || image === 'string' ? '/dashboard/viewPack-default.png' : image;

      const { widgetType, chartType: chartTypeValue = '', displayStyle = '' } = widgets;
      const isGroupWidget = widgetType === 'GROUP';

      // 그룹 위젯인데 이전 버전에서 만들어진 뷰팩은 chartType이 GROUP이 아닐 수 있음
      const chartType =
        isGroupWidget && !['TAB_GROUP', 'GROUP'].includes(chartTypeValue)
          ? 'GROUP'
          : chartTypeValue;

      const iconClass = getViewPackIconClass(chartType, displayStyle);

      return {
        id: `${packId}`,
        isVisible: true,
        name,
        description,
        imgSrc: convertToImageURL(imgSrc, 'viewPack'),
        packType,
        createUserName,
        createUserRole,
        tag,
        category,
        viewPackOptions,
        iconClass,
      };
    },
  );

export const targetKindToCategory = (targetKind: string): Category => {
  switch (targetKind) {
    case 'application':
      return 'app';
    case 'cluster':
      return 'k8s';
    default:
      return targetKind as Category;
  }
};
